package com.vidaensupalabra.vsp.ventanas

import androidx.compose.runtime.*
import kotlinx.browser.window
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import com.vidaensupalabra.vsp.ui.theme.*
import com.vidaensupalabra.vsp.datos.ComunidadPost
import com.vidaensupalabra.vsp.navigation.Router
import com.vidaensupalabra.vsp.navigation.Screen

@Composable
internal fun AdminBadge(esAdmin: Boolean) {
    if (esAdmin) {
        Span(attrs = {
            style {
                backgroundColor(VspMarco)
                color(White)
                fontSize(10.px)
                fontWeight("bold")
                padding(2.px, 6.px)
                borderRadius(12.px)
                marginLeft(8.px)
            }
        }) { Text("👑 Admin") }
    }
}

@Composable
internal fun LinkPreviewCard(url: String, title: String, desc: String, imageUrl: String?, onClear: (() -> Unit)? = null) {
    Div(attrs = {
        style {
            display(DisplayStyle.Flex); flexDirection(if (imageUrl != null) FlexDirection.Column else FlexDirection.Row)
            backgroundColor(rgba(0,0,0,0.3)); borderRadius(8.px)
            property("border-left", "4px solid $VspMarco"); property("overflow", "hidden")
            marginTop(12.px); cursor("pointer"); position(Position.Relative)
        }
        onClick { window.open(url, "_blank") }
    }) {
        if (onClear != null) {
            Button(attrs = {
                onClick { it.nativeEvent.stopPropagation(); onClear() }
                style { position(Position.Absolute); top(8.px); right(8.px); backgroundColor(rgba(0,0,0,0.6)); color(White); border(0.px); borderRadius(50.percent); width(24.px); height(24.px); cursor("pointer") }
            }) { Text("✕") }
        }
        if (imageUrl != null) {
            Img(src = imageUrl, attrs = { style { width(100.percent); maxHeight(150.px); property("object-fit", "cover") } })
        }
        Div(attrs = { style { padding(12.px); display(DisplayStyle.Flex); flexDirection(FlexDirection.Column); gap(4.px) } }) {
            Span(attrs = { style { color(White); fontWeight("bold"); fontSize(14.px); property("display", "-webkit-box"); property("-webkit-line-clamp", "2"); property("-webkit-box-orient", "vertical"); property("overflow", "hidden") } }) { Text(title) }
            if (desc.isNotBlank()) Span(attrs = { style { color(rgba(255,255,255,0.6)); fontSize(12.px); property("display", "-webkit-box"); property("-webkit-line-clamp", "2"); property("-webkit-box-orient", "vertical"); property("overflow", "hidden") } }) { Text(desc) }
            Span(attrs = { style { color(VspMarco); fontSize(11.px); marginTop(4.px) } }) { Text(url.substringAfter("://").substringBefore("/")) }
        }
    }
}

@Composable
internal fun PostImage(url: String) {
    var showDialog by remember { mutableStateOf(false) }

    // Imagen normal en la publicación
    Img(src = url, alt = "Imagen adjunta", attrs = {
        onClick { showDialog = true }
        style { width(100.percent); borderRadius(12.px); marginBottom(16.px); property("object-fit", "contain"); cursor("zoom-in") }
    })

    // Modal de pantalla completa
    if (showDialog) {
        Div(attrs = {
            onClick { showDialog = false }
            style {
                position(Position.Fixed); top(0.px); left(0.px); width(100.vw); height(100.vh)
                backgroundColor(rgba(0, 0, 0, 0.9)); property("z-index", 2000)
                display(DisplayStyle.Flex); justifyContent(JustifyContent.Center); alignItems(AlignItems.Center)
                cursor("zoom-out")
            }
        }) {
            Img(src = url, alt = "Imagen ampliada", attrs = {
                style { maxWidth(95.percent); maxHeight(95.percent); property("object-fit", "contain") }
            })
        }
    }
}

@Composable
internal fun FormInput(label: String, value: String, onValueChange: (String) -> Unit, placeholder: String) {
    Div(attrs = { style { display(DisplayStyle.Flex); flexDirection(FlexDirection.Column); gap(4.px) } }) {
        Label(attrs = { style { color(White); fontSize(14.px) } }) { Text(label) }
        Input(type = InputType.Text, attrs = {
            value(value)
            onInput { onValueChange(it.value) }
            attr("placeholder", placeholder)
            style {
                width(100.percent); padding(12.px); borderRadius(8.px)
                border(1.px, LineStyle.Solid, VspMarco); backgroundColor(VspMarcoTransparente50)
                color(White); fontSize(16.px); boxSizing("border-box")
            }
        })
    }
}

@Composable
internal fun BirthdateDialog(onSubmit: (String) -> Unit) {
    var date by remember { mutableStateOf("") }

    Div(attrs = { style { position(Position.Fixed); top(0.px); left(0.px); width(100.vw); height(100.vh); backgroundColor(rgba(0, 0, 0, 0.8)); property("z-index", 2000); display(DisplayStyle.Flex); justifyContent(JustifyContent.Center); alignItems(AlignItems.Center) } }) {
        Div(attrs = { style { backgroundColor(VspBase); padding(24.px); borderRadius(16.px); display(DisplayStyle.Flex); flexDirection(FlexDirection.Column); alignItems(AlignItems.Center); maxWidth(400.px); width(90.percent); boxSizing("border-box") } }) {
            H3(attrs = { style { color(White); marginTop(0.px); textAlign("center") } }) { Text("¡Bienvenido a la Comunidad!") }
            P(attrs = { style { color(rgba(255,255,255,0.7)); textAlign("center"); fontSize(14.px); marginBottom(24.px); lineHeight("1.5") } }) { Text("Para completar tu perfil, por favor ingresa tu fecha de nacimiento:") }
            Input(type = InputType.Date, attrs = { value(date); onInput { date = it.value }; style { padding(12.px); borderRadius(8.px); border(1.px, LineStyle.Solid, VspMarco); fontSize(16.px); marginBottom(24.px); width(100.percent); boxSizing("border-box") } })
            Button(attrs = { onClick { if (date.isNotBlank()) onSubmit(date) else window.alert("Por favor selecciona una fecha.") }; style { width(100.percent); padding(12.px); backgroundColor(VspMarco); color(White); fontWeight("bold"); border(0.px); borderRadius(8.px); cursor("pointer"); fontSize(16.px) } }) { Text("Guardar y Continuar") }
        }
    }
}

@Composable
internal fun FullScreenLoader(message: String) {
    Div(attrs = { style { position(Position.Fixed); top(0.px); left(0.px); width(100.vw); height(100.vh); backgroundColor(rgba(0, 0, 0, 0.8)); property("z-index", 3000); display(DisplayStyle.Flex); flexDirection(FlexDirection.Column); justifyContent(JustifyContent.Center); alignItems(AlignItems.Center) } }) {
        Div(attrs = { style { width(50.px); height(50.px); property("border", "5px solid rgba(255,255,255,0.2)"); property("border-top-color", VspMarco.toString()); borderRadius(50.percent); property("animation", "spin 1s linear infinite"); marginBottom(16.px) } })
        P(attrs = { style { color(White); fontSize(16.px); fontWeight("bold"); margin(0.px) } }) { Text(message) }
    }
}

@Composable
internal fun PostCard(post: ComunidadPost, currentUser: FirebaseUser?, fontSize: Int, onClick: () -> Unit, onToggleAmen: (Boolean) -> Unit, onShare: () -> Unit) {
    Div(attrs = {
        onClick { onClick() }
        style {
            backgroundColor(VspMarcoTransparente50)
            borderRadius(12.px); padding(16.px); cursor("pointer")
            property("box-shadow", "0px 4px 6px rgba(0,0,0,0.1)")
        }
    }) {
        H3(attrs = { style { color(VspMarco); margin(0.px, 0.px, 8.px, 0.px); fontSize(20.px) } }) { Text(post.titulo) }
        Div(attrs = { style { display(DisplayStyle.Flex); alignItems(AlignItems.Center); marginBottom(12.px) } }) {
            val onProfileClick = { Router.navigateTo(Screen.Perfil(post.userId, post.autor, post.autorFoto)) }
            if (post.autorFoto != null) {
                Img(src = post.autorFoto, attrs = { onClick { it.nativeEvent.stopPropagation(); onProfileClick() }; style { width(24.px); height(24.px); borderRadius(50.percent); marginRight(8.px); cursor("pointer") } })
            }
            Span(attrs = { onClick { it.nativeEvent.stopPropagation(); onProfileClick() }; style { color(White); fontWeight("bold"); fontSize(14.px); flex(1); cursor("pointer") } }) { Text(post.autor) }
            AdminBadge(post.esAdmin)
            Span(attrs = { style { color(rgba(255, 255, 255, 0.5)); fontSize(12.px) } }) { Text(post.fecha) }
        }
        key(post.contenido) {
            Div(attrs = {
                classes("post-preview-text")
                style {
                    color(White); margin(0.px); lineHeight("1.5")
                    property("display", "-webkit-box"); property("-webkit-line-clamp", "3")
                    property("-webkit-box-orient", "vertical"); property("overflow", "hidden"); fontSize(fontSize.px)
                }
                ref { it.innerHTML = parsearMarkdownBasico(post.contenido); onDispose {} }
            })
        }
        if (post.youtubeVideoId != null || post.imagenUrl != null) {
            Div(attrs = { style { marginTop(12.px); color(VspMarco); fontSize(12.px); fontWeight("bold") } }) { Text(if (post.youtubeVideoId != null) "▶ Contiene Video" else "🖼️ Contiene Imagen") }
        }
        if (post.linkPreviewUrl != null && post.linkPreviewTitle != null) {
            LinkPreviewCard(post.linkPreviewUrl, post.linkPreviewTitle, post.linkPreviewDesc ?: "", post.linkPreviewImage)
        }
        Div(attrs = { style { display(DisplayStyle.Flex); gap(16.px); marginTop(16.px); paddingTop(12.px); property("border-top", "1px solid rgba(255,255,255,0.1)") } }) {
            val hasAmen = currentUser != null && post.amens.containsKey(currentUser.uid)
            Span(attrs = {
                onClick { it.nativeEvent.stopPropagation(); onToggleAmen(!hasAmen) }
                style { color(if (hasAmen) VspMarco else White); fontWeight("bold"); cursor("pointer"); fontSize(14.px) }
            }) { Text("👏 Amén (${post.amens.size})") }
            Span(attrs = { style { color(rgba(255, 255, 255, 0.7)); fontSize(14.px) } }) { Text("💬 Comentarios (${post.comentarios.size})") }
            Span(attrs = {
                onClick { it.nativeEvent.stopPropagation(); onShare() }
                style { color(White); cursor("pointer"); fontSize(14.px); property("margin-left", "auto") }
            }) { Text("📤 Compartir") }
        }
    }
}